const TOPOLOGY_FILE_TYPE = 'NVQual System Topology'
const IMAGE_FILE_TYPE = 'Image'

const FILE_TYPES = Object.freeze([
  TOPOLOGY_FILE_TYPE,
  IMAGE_FILE_TYPE,
])

export {
  TOPOLOGY_FILE_TYPE,
  IMAGE_FILE_TYPE,
  FILE_TYPES
}
